<template>
    <Drawer
        width="1024"
        placement="right"
        :closable="false"
        :visible="visible"
        v-bind="$attrs"
        v-on="$listeners"
        @close="close"
    >
        <div
            slot="title"
            class="flex items-center justify-between"
        >
            {{ $t('measureAccess') }}
            <AntButton
                type="primary"
                @click="save"
            >
                {{ $t('save') }}
            </AntButton>
        </div>
        <Spin :spinning="!hasFetched">
            <MeasureTransfer
                :access="access"
                :measures="measures"
                @on-change="change"
            />
        </Spin>
    </Drawer>
</template>

<script>
import MeasureTransfer from './MeasureTransfer';
import { Button, Spin } from 'ant-design-vue';
import drawerMixin from '@/mixins/drawerMixin';
import { mapActions } from 'vuex';

export default {
    name: 'MeasureAccessDrawer',
    components: {
        Spin,
        MeasureTransfer,
        AntButton: Button,
    },
    mixins: [drawerMixin],
    props: {
        customerId: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            measures: [],
            access: [],
            selectedMeasures: [],
            hasFetched: false,
        };
    },
    created() {
        this.$on('show', async () => {
            if (this.hasFetched) {
                return;
            }

            this.measures = await this.$http.get('measures?concept=false');
            this.access = await this.$http.get(`customers/${this.customerId}/measure-access`);
            this.hasFetched = true;
        });
    },
    methods: {
        ...mapActions({
            updateMeasureAccess: 'customers/updateMeasureAccess',
        }),
        change(measures) {
            this.selectedMeasures = measures;
        },
        async save() {
            this.close();

            await this.updateMeasureAccess(this.selectedMeasures);

            this.$notification.success({
                message: this.$t('entitySaved', {
                    entity: this.$t('measureAccess'),
                }),
            });
        },
    },

};
</script>

<style>

</style>